class ExtraBoxQuantity extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
    this.line = parseInt(this.dataset.line || '0', 10) || 0;
    this.input = this.querySelector('[data-extra-box-qty]');
    this.loadingOverlay = this.querySelector('.loading-overlay');
    this._debounceTimer = null;
    this._isUpdating = false;
    this._lastQty = this._getQty();

    if (!this.variantId || !this.input) return;

    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);

    this.input.addEventListener('input', this._onInput);
    this.input.addEventListener('change', this._onChange);
  }

  _getQty() {
    const n = parseInt(this.input?.value || '0', 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  _setQty(qty) {
    const safe = Number.isFinite(qty) && qty > 0 ? Math.floor(qty) : 0;
    if (this.input) this.input.value = String(safe);
    return safe;
  }

  _lockUI(lock) {
    if (this.loadingOverlay) this.loadingOverlay.classList.toggle('hidden', !lock);
    const nodes = this.querySelectorAll('button, input');
    nodes.forEach((el) => {
      if (el.matches('input')) el.readOnly = lock;
      else el.disabled = lock;
    });
  }

  _getCartItemsEl() {
    const mini = this.closest('mini-cart');
    if (mini) {
      const el = mini.querySelector('cart-items');
      if (el) return el;
    }
    return document.querySelector('cart-items');
  }

  _getSectionIds(cartItemsEl) {
    const ids = new Set();
    if (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') {
      cartItemsEl.getSectionsToRender().forEach((s) => {
        if (s && s.section) ids.add(s.section);
      });
    }
    const miniCartEl = document.querySelector('mini-cart');
    if (miniCartEl && typeof miniCartEl.getSectionsToRender === 'function') {
      miniCartEl.getSectionsToRender().forEach((s) => {
        const id = (s && (s.section || s.id)) || null;
        if (id) ids.add(id);
      });
    }
    if (document.getElementById('mini-cart')) ids.add('mini-cart');
    if (document.getElementById('cart-icon-bubble')) ids.add('cart-icon-bubble');
    if (document.getElementById('mobile-cart-icon-bubble')) ids.add('mobile-cart-icon-bubble');
    if (document.getElementById('cart-live-region-text')) ids.add('cart-live-region-text');
    return Array.from(ids);
  }

  _queueUpdate(qty, immediate = false) {
    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = null;
    }
    if (immediate) {
      this._updateCart(qty);
      return;
    }
    this._debounceTimer = setTimeout(() => {
      this._debounceTimer = null;
      this._updateCart(qty);
    }, 250);
  }

  _onInput() {
    const qty = this._setQty(this._getQty());
    if (qty === this._lastQty) return;
    this._queueUpdate(qty, false);
  }

  _onChange() {
    const qty = this._setQty(this._getQty());
    if (qty === this._lastQty) return;
    this._queueUpdate(qty, true);
  }

  _updateCart(qty) {
    const safeQty = this._setQty(qty);
    if (this._isUpdating) return;
    this._isUpdating = true;
    this._lockUI(true);

    const cartItemsEl = this._getCartItemsEl();
    const sections = this._getSectionIds(cartItemsEl);

    const body = JSON.stringify({
      updates: { [this.variantId]: safeQty },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(theme.routes.cart_update_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState && parsedState.errors) throw parsedState.errors;

        if (cartItemsEl && typeof cartItemsEl.renderContents === 'function') {
          cartItemsEl.renderContents(parsedState);
        } else {
          const miniCartEl = document.querySelector('mini-cart');
          if (miniCartEl && typeof miniCartEl.renderContents === 'function') miniCartEl.renderContents(parsedState);
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'extra-box-quantity', cartData: parsedState, variantId: this.variantId });
        }

        this._lastQty = safeQty;
      })
      .catch(() => {
        this._setQty(this._lastQty);
      })
      .finally(() => {
        this._isUpdating = false;
        this._lockUI(false);
      });
  }
}

customElements.define('extra-box-quantity', ExtraBoxQuantity);
